import React from 'react';
import Skeleton from '../../../reusable/Skeleton/Skeleton';
import AnalysisSubSection from './AnalysisSubSection';
import { useGetAccountAnalysisQuery } from '../../../store/api/metricsApi';
import { t } from '../../../i18n/i18n';
import './AccountAnalysis.scss';

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

export default function AccountAnalysis({ loginId, platform, account }) {
  // Live API from main branch: GET /v2/account-analysis/?login_id=<login>&platform=<platform>
  const { data, isLoading, isFetching, isError, error } = useGetAccountAnalysisQuery(
    { loginId, platform },
    { skip: !loginId }
  );

  const isDataLoading = !loginId || isLoading || isFetching;

  return (
    <div className="am-analysis">
      {/* Account Analysis Header */}
      <header className="am-analysis__header">
        <div className="am-analysis__nav-title">
          <span className="icon am-analysis__nav-icon" style={icon('metrics-statistics')} />
          <h2>{t('Account Analysis')}</h2>
        </div>
        <span className="am-card__meta">{t('Detailed trade & instrument breakdown')}</span>
      </header>

      {isDataLoading ? (
        <div className="am-analysis__loading">
          <Skeleton height={52} radius="card" />
          <Skeleton height={140} radius="card" />
          <Skeleton height={260} radius="card" />
        </div>
      ) : isError ? (
        <div className="am-analysis__empty-card">
          <p>
            {error?.data?.detail ||
              error?.data?.message ||
              t('Could not load account analysis data at this time.')}
          </p>
        </div>
      ) : !data || Object.keys(data).length === 0 ? (
        <div className="am-analysis__empty-card">
          <p>{t('No account analysis data available for this account yet.')}</p>
        </div>
      ) : (
        <AnalysisSubSection data={data} />
      )}
    </div>
  );
}
